/** Below this width (px) the app renders its mobile tree, phone patterns included. */
export const MOBILE_BREAKPOINT = 768;

/**
 * From this width (px) a desktop screen shows three columns side by side — the
 * conversation list, the chat and a panel. Below it, two at most: opening a
 * panel folds the list, which comes back over the chat when asked for. The
 * `compact` variant in `index.css` uses the same width.
 */
export const WIDE_DESKTOP_MIN_WIDTH = 1600;
